import React, { useState, useEffect, useRef, useContext } from "react";
import Select from "react-select";
import { useRouter } from "next/router";
import ScrollableTable from "../../../components/table/ScrollableTable";
import MainLayout from "../../../components/MainLayout/MainLayout";
import { TableHeader } from "../../../components/table/TableHeader";
import Utils from "../../../utils/Utils";
import { AppContext } from "../../../context/state";
import { appServerSideProps } from "../../../utils/getAppService";
import WinningMetrics from "../../../components/WinningMetrics";
import { SQHeaderLockContent } from "../../../components/SQPremiumLock/SQPremiumLock";
function useQuery() {
  return new URLSearchParams(useRouter());
}

const spreadsTableHeader = [
  {
    title: "Type",
    showImage: false,
    sortable: true,
    key: "Type",
  },
  {
    title: "Wins",
    showImage: false,
    sortable: true,
    key: "Wins",
  },
  {
    title: "Losses",
    showImage: false,
    sortable: true,
    key: "Losses",
  },
  {
    title: "Pushes",
    showImage: false,
    sortable: true,
    key: "Pushes",
  },
  {
    title: "Units",
    showImage: false,
    sortable: true,
    key: "Units",
  },

  {
    title: "Win %",
    showImage: false,
    sortable: true,
    key: "Win_%",
    offen: "hmarg",
    defen: "tot",
  },
  {
    title: "Units Risked",
    showImage: false,
    sortable: true,
    key: "Units_Risked",
    offen: "concen",
    defen: "concentot",
  },
  {
    title: "ROI",
    showImage: false,
    sortable: true,
    key: "ROI",
    offen: "teamval",
    defen: "totside",
  },
];

export const timePeriodOptions = [
  {
    label: "Last 7 days",
    value: "last7",
  },
  {
    label: "Last 14 days",
    value: "last14",
  },
  {
    label: "Last 30 days",
    value: "last30",
  },
  {
    label: "Season",
    value: "all",
  },
];
const today = new Date();
export const timeFrame = {
  last7: "Last 7 days",
  last14: "Last 14 days",
  last30: "Last 30 days",
  all: today.getFullYear() + "-" + (today.getFullYear() + 1 - 2000) + " Season",
};

let ascOrder = true;

const BettingResults = ({ user }) => {
  const router = useRouter();
  let query = useQuery();
  let leagueFromUrl = router.query?.league;
  const tableRef = useRef();
  const { store, setStore } = useContext(AppContext);
  const [favorite, setFavorite] = useState(null);
  const [underdog, setUnderdog] = useState(null);
  const [over, setOver] = useState(null);
  const [under, setUnder] = useState(null);
  const [summary, setSummary] = useState(null);
  const [sortedKey, setSortedKey] = useState("");
  const [columnType, setColumnType] = useState(() => {
    return query.get("columnType") ?? "offen";
  });
  const [timePeriod, setTimePeriod] = useState("all");

  if (leagueFromUrl === "ncaa") {
    leagueFromUrl = "college_mens";
  }
  const isStandardPlan = Utils.hasStandardPlan(user);
  const isPremiumPlan = Utils.hasPremiumPlan(user);
  const isPaidPlan = (isStandardPlan || isPremiumPlan) && user.has_paid;
  useEffect(() => {
    setStore({ ...store, leagueType: leagueFromUrl ? leagueFromUrl : store.leagueType });
  }, [leagueFromUrl]);

  useEffect(() => {
    fetch(
      `${process.env.NEXT_PUBLIC_API_URL_API_URL}/api/${
        leagueFromUrl ? leagueFromUrl : store.leagueType
      }/results_summary/${timePeriod}`
    )
      .then((d) => d.json())
      .then((response) => {
        setSummary(response.data[0]);
        setUnderdog(response.data[1]);
        setFavorite(response.data[2]);
        setOver(response.data[3]);
        setUnder(response.data[4]);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [store, leagueFromUrl, timePeriod]);

  const sort = (key) => {
    let res = [];
    let rawData = [];

    let replaceKey;
    const headerObj = spreadsTableHeader.filter((column) => column["key"] === key)[0];

    replaceKey = headerObj["key"];

    if (key === "play") {
      replaceKey = "finalval";
    }

    if (key === "concen") {
      if (columnType === "defen") {
        replaceKey = "concentot";
      } else {
        replaceKey = "concen";
      }
    }

    if (key === "finalval") {
      if (columnType === "defen") {
        replaceKey = "totalval";
      } else {
        replaceKey = "finalval";
      }
    }

    if (sortedKey === key) {
      let order = ascOrder ? "asc" : "desc";

      res = rawData.sort(Utils.dynamicsort(replaceKey, order));
      ascOrder = order === "desc";
    } else {
      ascOrder = false;
      setSortedKey(key);
      res = rawData.sort(Utils.dynamicsort(replaceKey));
    }
  };

  const handleDownloadCSV = (e) => {
    e.preventDefault();
    const modifiedResult = [];
    modifiedResult.push({
      Type: "Favorite",
      ...favorite,
      "Win %":
        Math.trunc(Number((favorite?.Wins * 100) / (favorite?.Wins + favorite?.Losses).toFixed(2)) * 100) / 100 + "%",
    });
    modifiedResult.push({
      Type: "Underdog",
      ...underdog,
      "Win %":
        Math.trunc(Number((underdog?.Wins * 100) / (underdog?.Wins + underdog?.Losses).toFixed(2)) * 100) / 100 + "%",
    });
    modifiedResult.push({
      Type: "Over",
      ...over,
      "Win %": Math.trunc(Number((over?.Wins * 100) / (over?.Wins + over?.Losses).toFixed(2)) * 100) / 100 + "%",
    });
    modifiedResult.push({
      Type: "Under",
      ...under,
      "Win %": Math.trunc(Number((under?.Wins * 100) / (under?.Wins + under?.Losses).toFixed(2)) * 100) / 100 + "%",
    });
    Utils.jsonToCsv(modifiedResult);
  };
  return (
    <MainLayout>
      <main id="ContentBox" style={{ minHeight: "100vh" }}>
        <div className="MiscStats Sandbox">
          <section className="header-secondary">
            <div className="container-fluid">
              {/* <button
                style={{
                  background: "transparent",
                  border: 0,
                  color: "#0F131B",
                  fontSize: "16px",
                  fontWeight: 700,
                  marginTop: "10px",
                  marginBottom: "30px",
                }}
              >
                {"<  "} Back to Model Projections
              </button> */}

              <div className="row d-flex justify-content-between align-items-center">
                <div className="col-md-4"></div>
                <div className="col-md-4">
                  <h1 className="text-center" style={{ fontSize: "36px", marginBottom: 0 }}>
                    {timeFrame[timePeriod]} <br></br>Betting Results
                  </h1>
                </div>
                <div className="col-md-4">
                  <div className="selectWrapper" style={{ width: "242px", marginLeft: "auto" }}>
                    <p>Time Frames</p>
                    <Select
                      defaultValue={{
                        label: "Season",
                        value: "all",
                      }}
                      options={timePeriodOptions}
                      onChange={(e) => {
                        setTimePeriod(e.value);
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                className="row d-flex mt-5 justify-content-between align-items-center"
                style={{
                  backgroundColor: "#fff",
                  boxShadow: "2px 4px 30px rgba(107, 108, 114, 0.12)",
                  borderRadius: "12px",
                  padding: "30px 50px 30px 40px",
                }}
              >
                <>
                  <div className="col-md-6" style={{ borderRight: "1px solid #D0D2D9" }}>
                    <div>
                      <h2>Overall</h2>
                      <p
                        style={{
                          fontSize: "16px",
                          color: "#0F131B",
                          marginTop: "16px",
                        }}
                      >
                        The ShotQualityBets model is{" "}
                        <span
                          style={{ color: "#F26B0B" }}
                        >{`${summary?.Wins}-${summary?.Losses}-${summary?.Pushes}`}</span>{" "}
                        , winning <span style={{ color: "#F26B0B" }}>{summary?.Units}</span> units with a{" "}
                        <span style={{ color: "#F26B0B" }}>{summary?.ROI}</span> ROI
                      </p>
                    </div>
                  </div>
                  <div className="col-md-6 d-flex justify-content-around">
                    <div className="text-center">
                      <p>The ShotQualityBets model</p>{" "}
                      <h3
                        style={{
                          fontWeight: 700,
                          fontFamily: "var(--font-oswald)",
                          fontSize: "32px",
                        }}
                      >
                        {`${summary?.Wins}-${summary?.Losses}-${summary?.Pushes}`}
                      </h3>
                    </div>
                    <div className="text-center">
                      <p>Winning</p>{" "}
                      <h3
                        style={{
                          fontWeight: 700,
                          fontFamily: "var(--font-oswald)",
                          fontSize: "32px",
                        }}
                      >
                        {summary?.Units}
                      </h3>
                    </div>
                    <div className="text-center">
                      <p>Units with</p>{" "}
                      <h3
                        style={{
                          fontWeight: 700,
                          fontFamily: "var(--font-oswald)",
                          fontSize: "32px",
                        }}
                      >
                        {summary?.ROI} ROI
                      </h3>
                    </div>
                  </div>
                </>
              </div>
              <div>
                <ScrollableTable top="0px" ref={tableRef}>
                  <div className="table-responsive table-space mt-4">
                    <h3 style={{ display: "inline-block" }}>Spreads</h3>
                    {isPremiumPlan && (
                      <button className="btn export-button float-right mb-2" onClick={handleDownloadCSV}>
                        Export to CSV
                      </button>
                    )}
                    <table className="table tl-fixed-desktop">
                      <thead className="sticky-th-2">
                        <tr className="text-center">
                          <TableHeader
                            headers={spreadsTableHeader}
                            onSortClick={sort}
                            ascOrder={ascOrder}
                            sortedKey={sortedKey}
                          />
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>Favorite</td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              favorite?.Wins
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              favorite?.Losses
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              favorite?.Pushes
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              favorite?.Units
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              Math.trunc(
                                Number((favorite?.Wins * 100) / (favorite?.Wins + favorite?.Losses).toFixed(2)) * 100
                              ) /
                                100 +
                              "%"
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              favorite?.Units_Risked
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              favorite?.ROI
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Underdog</td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              underdog?.Wins
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              underdog?.Losses
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              underdog?.Pushes
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              underdog?.Units
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              Math.trunc(
                                Number((underdog?.Wins * 100) / (underdog?.Wins + underdog?.Losses)).toFixed(2) * 100
                              ) /
                                100 +
                              "%"
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              underdog?.Units_Risked
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              underdog?.ROI
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ScrollableTable>
              </div>
              <div>
                <ScrollableTable top="0px" ref={tableRef}>
                  <div className="table-responsive table-space">
                    <h3>Totals</h3>
                    <table className="table tl-fixed-desktop">
                      <thead className="sticky-th-2">
                        <tr className="text-center">
                          <TableHeader
                            headers={spreadsTableHeader}
                            onSortClick={sort}
                            ascOrder={ascOrder}
                            sortedKey={sortedKey}
                          />
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={{ textAlign: "center" }}>Over</td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              over?.Wins
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              over?.Losses
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              over?.Pushes
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              over?.Units
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              Math.trunc(Number((over?.Wins * 100) / (over?.Wins + over?.Losses)).toFixed(2) * 100) /
                              100
                            )}
                            %
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              over?.Units_Risked
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              over?.ROI
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td style={{ textAlign: "center" }}>Under</td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              under?.Wins
                            )}
                          </td>{" "}
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              under?.Losses
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              under?.Pushes
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              under?.Units
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              Math.trunc(Number((under?.Wins * 100) / (under?.Wins + under?.Losses)).toFixed(2) * 100) /
                                100 +
                              "%"
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              under?.Units_Risked
                            )}
                          </td>
                          <td className={isPaidPlan ? "" : "data-blur"} style={{ textAlign: "center" }}>
                            {" "}
                            {!isPaidPlan ? (
                              <>
                                <TableHeader headers={SQHeaderLockContent} />
                                78.9
                              </>
                            ) : (
                              under?.ROI
                            )}
                          </td>{" "}
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </ScrollableTable>
              </div>
            </div>
          </section>
          <WinningMetrics targetPage={"BettingAnalysis"} />
        </div>
      </main>
    </MainLayout>
  );
};
export const getServerSideProps = appServerSideProps(async ({ appService }) => {
  const isUserLogged = appService.getUser();

  let user = null;

  if (isUserLogged) {
    user = await appService.get("api/account");
  }
  if (Utils.isTrader(user)) {
    return {
      redirect: {
        destination: "/trader-dashboard",
        permanent: false,
      },
    };
  }
  return { props: { user } };
});
export default BettingResults;
